import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const CreditLimit = () => {
  const data = [
    ['Customer', 'Credit Limit (₹ in Thousands)'],
    ['Customer A', 50],
    ['Customer B', 40],
    ['Customer C', 60],
    ['Customer D', 55],
    ['Customer E', 45],
  ];

  const options = {
    title: 'Credit Limit',
    hAxis: { title: 'Customer' },
    vAxis: { title: 'Credit Limit (₹ in Thousands)' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#2196F3'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default CreditLimit;